import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { EncyclopediaRelation, EncyclopediaRelationPaginationFilterRequest, UpsertEncyclopediaRelation } from '@/models/encyclopedia-relation.model';

export const getPagedEncyclopediaRelations = async (input: EncyclopediaRelationPaginationFilterRequest): Promise<PagedResponseModel<EncyclopediaRelation>> => {
  return await getReq(createUrl("a/Encyclopedia/Relation/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getEncyclopediaRelation = async (id: number): Promise<BaseResponseModel<EncyclopediaRelation>> => {
  return await getReq(createUrl(`a/Encyclopedia/Relation/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertEncyclopediaRelation = async (input: UpsertEncyclopediaRelation): Promise<BaseResponseModel<EncyclopediaRelation>> => {
  return await postReq(createUrl("a/Encyclopedia/Relation/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteEncyclopediaRelation = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/Encyclopedia/Relation/Delete/${id}`),
  ).then((res: any) => res.data);
};
